// SPRAYS:
module.exports = [{
  name: "Krunker",
  opacity: 0.6
}, {
  name: "Target",
  opacity: 0.6
}, {
  name: "GG",
  opacity: 0.6
}, {
  name: "Pumpkin",
  opacity: 0.6
}, {
  name: "Spooky",
  opacity: 0.6
}, {
  name: "Ded",
  opacity: 0.6
}, {
  name: "Sadface",
  opacity: 0.6
}, {
  name: "Laugh Cry",
  opacity: 0.7
}, {
  name: "Sid",
  opacity: 0.9
}, {
  name: "Vince",
  opacity: 0.9
}, {
  name: "Kiki",
  opacity: 0.6
}, {
  name: "Ladder",
  opacity: 1.0
}, {
  name: "Dummy",
  opacity: 1.0
}, {
  name: "8 Ball",
  opacity: 0.6
}, {
  name: "xD",
  opacity: 0.6
}, {
  name: "MMOK",
  opacity: 0.7
}, {
  name: "Madman",
  opacity: 0.6
}, {
  name: "Terminal",
  opacity: 0.6
}, {
  name: "YODO",
  opacity: 0.6
}, {
  name: "Crayon",
  opacity: 0.6
}, {
  name: "Myth",
  opacity: 0.85
}, {
  name: "SpikyJohn",
  opacity: 0.85
}, {
  name: "LevelGaming",
  opacity: 0.9
}, {
  name: "PolarAce",
  opacity: 0.9
}, {
  name: "MrsYiibby",
  opacity: 0.85
}, {
  name: "Vraxooo",
  opacity: 0.85
}, {
  name: "Jazzmittens",
  opacity: 0.85
}, {
  name: "Wolfmaan",
  opacity: 0.85
}, {
  name: "KPL",
  opacity: 0.9
}, {
  name: "BV Hype",
  opacity: 0.85
}, {
  name: "LandPhil",
  opacity: 0.85
}, {
  name: "Deal With It",
  opacity: 0.9
}, {
  name: "Rice",
  opacity: 0.9
}, {
  name: "Lore",
  opacity: 0.95
}, {
  name: "Desu Sid",
  opacity: 0.85
}, {
  name: "Anomaly",
  opacity: 0.85
}, {
  name: "FaZe",
  opacity: 0.9
}];